import { reports } from "@/mocks/chigua";
import Tag from "./Tag";

export default function Reports() {
  return (
    <section id="report" className="bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-1.5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-bold uppercase tracking-wide text-secondary-700">晋级战报 Reports</p>
            <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              战果复盘，场场有回甘
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每一场对决的关键节点、晋级走向与背后逻辑都被复盘记录，帮你把整场比赛看明白。
          </p>
        </div>

        <div className="mt-9 grid gap-5 md:grid-cols-2">
          {reports.map((r, idx) => (
            <article
              key={r.title}
              className={`group flex flex-col overflow-hidden rounded-3xl bg-background-50 transition-transform hover:-translate-y-1 ${
                idx === 0 ? "md:col-span-2 md:flex-row" : ""
              }`}
            >
              <div
                className={`relative overflow-hidden ${
                  idx === 0 ? "h-52 md:h-auto md:w-[42%]" : "h-44"
                }`}
              >
                <img
                  src={
                    idx === 0
                      ? "https://readdy.ai/api/search-image?query=crowd%20of%20cheering%20watermelon%20characters%20in%20a%20stadium%20with%20confetti%2C%20dramatic%20comeback%20moment%2C%20vibrant%20coral%20red%20and%20green%20palette%20on%20warm%20cream%20background%2C%20playful%20sporting%20illustration%2C%20high%20energy%20composition&width=900&height=620&seq=chigua-report-01&orientation=landscape"
                      : idx === 1
                        ? "https://readdy.ai/api/search-image?query=watermelon%20character%20surrounded%20by%20rising%20arrows%20and%20sparkles%20representing%20momentum%20and%20comeback%2C%20coral%20red%20and%20green%20flat%20vector%20illustration%20on%20cream%20background%2C%20minimal%20clean&width=900&height=620&seq=chigua-report-02&orientation=landscape"
                        : idx === 2
                          ? "https://readdy.ai/api/search-image?query=tactical%20analysis%20scene%20with%20memo%20board%20and%20magnifying%20glass%20and%20watermelon%20pieces%2C%20editorial%20review%20concept%2C%20warm%20amber%20and%20cream%20palette%2C%20flat%20illustration%20clean%20composition&width=900&height=620&seq=chigua-report-03&orientation=landscape"
                          : "https://readdy.ai/api/search-image?query=group%20of%20diverse%20watermelon%20characters%20standing%20in%20line%20with%20numbered%20bibs%20like%20sporting%20teams%2C%20group%20phase%20summary%2C%20coral%20and%20green%20flat%20vector%20on%20cream%20background&width=900&height=620&seq=chigua-report-04&orientation=landscape"
                  }
                  alt={`晋级战报：${r.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute left-3 top-3">
                  <Tag tone={r.tone}>{r.tag}</Tag>
                </div>
              </div>

              <div className={`flex flex-1 flex-col p-5 md:p-6 ${idx === 0 ? "md:self-center" : ""}`}>
                <h3 className="font-heading text-lg leading-snug text-foreground-950 md:text-xl">
                  {r.title}
                </h3>
                <p className={`text-sm leading-relaxed text-foreground-600 ${idx === 0 ? "mt-3" : "mt-2 line-clamp-3"}`}>
                  {r.excerpt}
                </p>

                {idx === 0 && (
                  <ul className="mt-4 space-y-2 border-l-2 border-primary-300 pl-4">
                    {r.points.map((p) => (
                      <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-flashlight-fill mt-0.5 text-xs text-primary-500" aria-hidden="true"></i>
                        {p}
                      </li>
                    ))}
                  </ul>
                )}

                <div className={`flex items-center gap-3 text-xs text-foreground-500 ${idx === 0 ? "mt-5" : "mt-auto pt-4"}`}>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" aria-hidden="true"></i>
                    {r.date}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line" aria-hidden="true"></i>
                    {r.view}
                  </span>
                  <a href="#report" className="ml-auto inline-flex items-center gap-1 font-semibold text-primary-600 hover:text-primary-700">
                    展开复盘 <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}